import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { TypedMemo } from '../../common/types';
import { useUserToken } from '../../../redux/slices/appInfo/hooks';
import { LoadingView } from '../../common/views/LoadingView';
import { useSMLRouter } from '../../../routing/sml/hooks';
import { SMLRoutes } from '../../../routing/sml/SMLRoutes';
import { signInReturnTo } from '../../../routing/sml/signInReturnTo';

// Private routes render for every signed-in user. A user without a subscription
// sees the page with limited data and the pricing modal on top (SMLContainer).
// A signed-out visitor goes to sign-in. A deep link (an email link, the OAuth consent) keeps its
// page in `returnTo`; the start page needs none, because sign-in opens Home.
const PrivateOnlyRouteControllerComponent: React.FC<React.PropsWithChildren> = ({ children }) => {
  const userToken = useUserToken();
  const router = useSMLRouter();
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (userToken !== null) {
      return;
    }
    const returnTo = signInReturnTo(pathname, search);
    router.replace(SMLRoutes.auth, returnTo === null ? undefined : { returnTo });
  }, [router, userToken, pathname, search]);

  if (userToken === null) {
    return <LoadingView />;
  }

  return <>{children}</>;
};

export const PrivateOnlyRouteController = TypedMemo(PrivateOnlyRouteControllerComponent);
